import { render, staticRenderFns } from "./SingleSilderBlog.vue?vue&type=template&id=57d9a971&scoped=true"
import script from "./SingleSilderBlog.vue?vue&type=script&lang=js"
export * from "./SingleSilderBlog.vue?vue&type=script&lang=js"
import style0 from "./SingleSilderBlog.vue?vue&type=style&index=0&id=57d9a971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d9a971",
  null
  
)

export default component.exports